module.exports = __webpack_public_path__ + "img/male-elderly-foot.c6108679.svg";